module.exports = __webpack_public_path__ + "static/media/bg_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_2.png
// module id = 47
// module chunks = 0